import styled from "styled-components";

export const StyledLoading = styled.div`
  width: 100%;
  height: calc(100vh);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 1000000;
  pointer-events: none;
  transition: opacity 0.2s ease;
  &.fade-out {
    opacity: 0;
    pointer-events: all;
  }
  .loading-box {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    padding: 2.4rem;
    border-radius: 2.4rem;
    background-color: var(--loading-background);
    min-width: 11rem;
    gap: 1.2rem;
    .lottie-wrap {
      width: 8rem;
      height: 8rem;
      position: relative;
      & > div {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }
      svg g g:nth-child(0) path {
        /* stroke: rgba(255, 255, 255, 0.32); */
        /* stroke: red; */
      }
    }
    .success {
      width: 8rem;
      height: 8rem;
      /* background-color: blue; */
      position: relative;
      .circle {
        box-sizing: border-box;
        width: 7rem;
        height: 7rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        border: 1rem solid var(--bg-gray-normal);
        opacity: 0.3;
      }
      .wrap {
        width: 5rem;
        height: 5rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .bar1 {
          position: absolute;
          top: 46%;
          left: -0.1rem;
          transform: rotate(42deg);
          width: 3.2rem;
          height: 1.4rem;
          border-radius: 10rem;
          background-color: var(--bg-gray-2);
          overflow: hidden;
          z-index: 2;
        }
        .bar2 {
          position: absolute;
          top: 33%;
          right: -0.5rem;
          transform: rotate(308deg);
          width: 4.6rem;
          height: 1.4rem;
          border-radius: 10rem;
          background-color: var(--bg-gray-2);
          overflow: hidden;
          z-index: 1;
        }
        .bar .inner-bar {
          display: block;
          width: 0;
          height: 100%;
          background-color: var(--pri-blue-4);
          transition: all 0.2s ease;
          &.active {
            /* border-radius: 10rem; */
            width: 100%;
          }
        }
      }
    }
    .message {
      text-align: center;
      font: var(--title-small);
      color: var(--text-gray-normal);
    }
  }
`;
